const featureItems = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '严格的内容审核与安全防护，为读者提供安心无忧的阅读环境，远离恶意广告与跳转。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用高性能服务器集群与智能图片优化，确保漫画页面秒开，下拉式阅读体验丝滑流畅。',
  },
  {
    icon: 'ri-book-open-line',
    title: '海量漫画库',
    desc: '收录200+热门连载，覆盖奇幻、魔幻、萌系等多种题材，经典与最新作品一应俱全。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: '完美适配桌面、平板与手机端，无论使用何种设备都能获得一致的高品质阅读体验。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '无需注册',
    desc: '完全免费开放，无需登录即可畅读全部漫画，打开即看，方便省心，快速进入漫画世界。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          为什么数百万读者选择妖精漫画网
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200 p-5 md:p-6 text-center hover:border-primary-200 transition-all"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}